import { PopoverPosition } from '@material-ui/core';
import { fabric } from 'fabric';
import { PixelCrop } from 'react-image-crop';
import { AnnotationDefinitionCore, AnnotationOnImage, ImageBorderSettings } from '../../models/annotation.types';
import { imageZone } from '../../pages/Sessions/ImageZonesEditor/ZonesList/ZonesList.types';
import { IComment } from '../Comments/Comments.types';

export enum zoomFactorValue {
  percent50 = 0.5,
  percent75 = 0.75,
  percent100 = 1,
  percent200 = 2,
  percent300 = 3,
  percent400 = 4,
  percent500 = 5,
  screenWidth = 2.6,
  screenWidthAndHeight = 0.85,
}

export const minZoomFactor = zoomFactorValue.percent50;
export const maxZoomFactor = zoomFactorValue.percent500;
export const zoomFactorValues = [
  zoomFactorValue.percent50,
  zoomFactorValue.percent75,
  zoomFactorValue.percent100,
  zoomFactorValue.percent200,
  zoomFactorValue.percent300,
  zoomFactorValue.percent400,
  zoomFactorValue.percent500,
];

export type rotateAngleValue = 0 | 90 | 180 | 270;

export interface objectUrlWithZone {
  objectUrl: string;
  zone: imageZone | undefined;
}

export interface pageImageData {
  image: fabric.Image;
  pageNumber: number;
  orderIndex: number;
  pixelCrop: PixelCrop | undefined;
  pageCoords?: [fabric.Point, fabric.Point, fabric.Point, fabric.Point];
}

export interface commentImageData {
  image: fabric.Object;
  comment: IComment;
}

export interface commentGroupData {
  commentId: string;
  group: fabric.Group;
}

export interface AnnotationImageData {
  image: fabric.Object;
  annotation: AnnotationOnImage;
  annotationDefinitionCore: AnnotationDefinitionCore;
}

export interface commentImageDataWithPopperPosition extends commentImageData {
  x: number;
  y: number;
}

export interface urlWithPageNumber {
  url: string;
  pageNumber: number;
}

export interface AnnotationActionMenuPosition {
  annotation: AnnotationOnImage;
  position: PopoverPosition;
  imageSettings: ImageBorderSettings;
}

export enum PreviewActionType {
  clearComments,
  rotateComments,
  moveCommentsPopovers,

  clearCommentsZones,
}

export type PreviewAction<T = unknown> = {
  type: PreviewActionType;
  payload?: T;
};

export interface Coords {
  left: number;
  top: number;
}

export interface Point {
  x: number;
  y: number;
}

export interface AnnotationAddingModeObj {
  isAdding: boolean;
}
